import { Mail, MapPin, Clock } from "lucide-react";
import InquiryForm from "@/components/InquiryForm";

const LocationCard = ({ title, address, hours, email, testId }) => (
  <div className="lrg-card" data-testid={testId}>
    <h3 className="font-display text-base font-semibold text-[#F2EDE4] mb-4">{title}</h3>
    <div className="space-y-3 text-xs">
      <div className="flex items-start gap-3">
        <MapPin className="w-3.5 h-3.5 text-[#0D6B56] mt-0.5 shrink-0" />
        <span className="text-[#6B6E71]">{address}</span>
      </div>
      <div className="flex items-center gap-3">
        <Mail className="w-3.5 h-3.5 text-[#0D6B56] shrink-0" />
        <a href={`mailto:${email}`} className="text-[#F2EDE4] hover:text-[#C8F542] transition-colors">{email}</a>
      </div>
      <div className="flex items-start gap-3">
        <Clock className="w-3.5 h-3.5 text-[#0D6B56] mt-0.5 shrink-0" />
        <span className="text-[#6B6E71]">{hours}</span>
      </div>
    </div>
  </div>
);

const Contact = () => (
  <div className="pt-16" data-testid="contact-page" style={{ background: "var(--lrg-bg)" }}>
    <section className="py-20" style={{ background: "var(--lrg-surface)" }} data-testid="contact-hero">
      <div className="container-custom">
        <div className="overline mb-4">Get In Touch</div>
        <h1 className="font-editorial text-4xl sm:text-5xl font-medium text-[#F2EDE4] mb-4">Contact</h1>
        <p className="text-sm text-[#6B6E71] max-w-md">
          Lessons, clinics, match play, memberships — send an inquiry and our manager will be in touch.
        </p>
      </div>
    </section>

    <section className="section" data-testid="contact-form-section">
      <div className="container-custom">
        <div className="grid lg:grid-cols-3 gap-12">
          <div className="lg:col-span-1 space-y-4">
            <div className="overline mb-2">Locations</div>
            <LocationCard
              title="Baltimore"
              address="Coppermine Bare Hills (6 courts) & DS Timonium (3 courts)"
              hours="Mon–Sun: 3:30 PM – 9 PM"
              email="dreadsports.baltimore@gmail.com"
              testId="contact-location-baltimore"
            />
            <LocationCard
              title="Princeton — NJSC"
              address="11 Princess Road, Lawrence Township, NJ"
              hours="Key Club — 24/7 member access"
              email="Njsquashclub@gmail.com"
              testId="contact-location-princeton"
            />
          </div>
          <div className="lg:col-span-2">
            <div className="lrg-card">
              <h2 className="font-editorial text-2xl text-[#F2EDE4] mb-8">Send an Inquiry</h2>
              <InquiryForm testId="contact-form" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default Contact;
